<template>
  <v-menu
    ref="menu"
    :disabled="chargement"
    :open-on-hover="!estVueMobile"
    :max-width="estVueMobile ? 'calc(100vw - 16px)' : 'auto'"
    offset-y
    top
    :nudge-left="estVueMobile ? '' : '132'"
    content-class="elevation-0"
    transition="fade-transition"
    @input="onBasculeBulle"
  >
    <template v-slot:activator="{ on, attrs, value }">
      <div
        ref="jauge"
        :style="[sizeStyles]"
        class="user-indicator-jauge"
        v-bind="attrs"
        v-on="on"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          :viewBox="`${-diameter / 2} ${-diameter / 2} ${diameter} ${diameter}`"
        >
          <template v-if="chargement">
            <path
              :d="cheminPiste"
              :stroke-width="strokeWidth"
              class="user-indicator-jauge-piste"
            />
            <path
              :d="cheminPiste"
              :stroke-width="strokeWidth"
              :style="styleBalai"
              class="user-indicator-jauge-balai"
            />
          </template>
          <template v-else>
            <path
              :style="[repartitionsColorData['center'].colorStyles]"
              :class="[repartitionsColorData['center'].colorClasses]"
              :d="`M ${repartitionsCoords['center'].startCoord.x} ${repartitionsCoords['center'].startCoord.y} A ${radius} ${radius} 0 0 1 ${repartitionsCoords['center'].endCoord.x} ${repartitionsCoords['center'].endCoord.y}`"
              :stroke-width="strokeWidth"
              class="user-indicator-jauge-quarter"
            />
            <path
              :style="[repartitionsColorData['negative'].colorStyles]"
              :class="[repartitionsColorData['negative'].colorClasses]"
              :d="`M ${repartitionsCoords['negative'].startCoord.x} ${repartitionsCoords['negative'].startCoord.y} A ${radius} ${radius} 0 0 1 ${repartitionsCoords['negative'].endCoord.x} ${repartitionsCoords['negative'].endCoord.y}`"
              :stroke-width="strokeWidth"
              class="user-indicator-jauge-quarter"
            />
            <path
              :style="[repartitionsColorData['positive'].colorStyles]"
              :class="[repartitionsColorData['positive'].colorClasses]"
              :d="`M ${repartitionsCoords['positive'].startCoord.x} ${repartitionsCoords['positive'].startCoord.y} A ${radius} ${radius} 0 0 1 ${repartitionsCoords['positive'].endCoord.x} ${repartitionsCoords['positive'].endCoord.y}`"
              :stroke-width="strokeWidth"
              class="user-indicator-jauge-quarter"
            />
            <g
              v-if="data.value && !isParametresExploitationIncomplet"
              :transform="valueMarkerWrapperTransform"
            >
              <polygon
                :class="[valueColorData.colorClasses]"
                :points="valueMarkerPoints"
                :stroke-width="getSvgSize(markerStrokeWidth)"
                :style="[valueColorData.colorStyles]"
                :transform="valueMarkerTransform"
                class="value-marker"
              />
            </g>
          </template>
        </svg>

        <v-avatar
          :size="avatarSize"
          class="user-indicator-jauge-avatar"
        >
          <v-icon
            :class="[valueColorData.colorClasses]"
            :size="iconSize"
            :style="[valueColorData.colorStyles]"
          >
            {{ icon }}
          </v-icon>
        </v-avatar>
      </div>
    </template>
    <div
      ref="bulle"
      class="menu-item-resume "
      :class="estVueMobile ? '' : 'menu-item-resume__top'"
      :style="styleFleche"
    >
      <div
        v-if="isParametresExploitationIncomplet"
        class="align-self-center intro texte-gris-fonce"
        :class="estVueMobile ? '' : 'w-260'"
      >
        Complétez vos paramètres d'exploitation dans "Mon compte" pour accéder aux comparaisons
      </div>
      <div
        v-else-if="data.value != null"
        class="d-flex my-2"
        :class="estVueMobile ? 'flex-column' : 'justify-space-between'"
      >
        <div
          class="intro texte-gris-fonce"
          :class="estVueMobile ? '' : 'align-self-center mr-6'"
        >
          Moyenne de mon groupe
        </div>
        <div
          class="titre-h3 secondary--text"
          :class="estVueMobile ? '' : 'align-self-center'"
        >
          {{ dataGroupe | roundNumber(precision) }} {{ unite }}
        </div>
      </div>
      <div
        v-else
        class="align-self-center intro texte-gris-fonce"
        :class="estVueMobile ? '' : 'w-260'"
      >
        Données de groupe insuffisantes pour proposer une comparaison. Veuillez revoir votre groupe de comparaison
      </div>
    </div>
  </v-menu>
</template>

<script>
import { getTextColorData } from './colorUtils'
import { mesurerApresPlacement, positionFlecheSousActivateur, DUREE_AFFICHAGE_BULLE } from '@/utils/bulle'

export default {
  name: 'UserIndicatorJauge',
  props: {
    data: {
      type: Object,
      default: null
    },
    dataGroupe: {
      type: Number,
      default: null
    },
    unite: {
      type: String,
      default: 'ha'
    },
    precision: {
      type: Number,
      default: 0
    },
    size: {
      type: Number,
      default: 56
    },
    width: {
      type: Number,
      default: 8
    },
    centerColor: {
      type: String,
      default: 'grey lighten-2'
    },
    positiveColor: {
      type: String,
      default: 'success'
    },
    negativeColor: {
      type: String,
      default: 'warning'
    },
    repartition: {
      type: Object,
      default () {
        return {
          center: 50,
          negative: 25,
          positive: 25
        }
      }
    },
    icon: {
      type: String,
      default: 'mdi-account-multiple-outline'
    },
    iconCenterColor: {
      type: String,
      default: 'grey darken-2'
    },
    iconSize: {
      type: Number,
      default: 24
    },
    angleOffset: {
      type: Number,
      default: 20
    },
    markerSize: {
      type: Number,
      default: 10
    },
    markerStrokeWidth: {
      type: Number,
      default: 2
    },
    markerOffset: {
      type: Number,
      default: 5
    },
    isParametresExploitationIncomplet: {
      type: Boolean,
      default: false
    },
    chargement: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      radius: 20,
      positionFleche: null,
      minuterieFermeture: null
    }
  },

  computed: {
    estVueMobile () {
      return this.$vuetify.breakpoint.smAndDown
    },
    styleFleche () {
      return this.positionFleche != null ? { '--position-fleche': this.positionFleche + 'px' } : {}
    },

    cheminPiste () {
      const debut = this.getCoord(this.startAngle)
      const fin = this.getCoord(this.endAngle)
      const grandArc = this.totalAngle > 180 ? 1 : 0

      return `M ${debut.x} ${debut.y} A ${this.radius} ${this.radius} 0 ${grandArc} 1 ${fin.x} ${fin.y}`
    },

    longueurPiste () {
      return (2 * Math.PI * this.radius * this.totalAngle) / 360
    },

    longueurBalai () {
      return this.longueurPiste * 0.22
    },

    styleBalai () {
      return {
        '--longueur-piste': this.longueurPiste + 'px',
        '--longueur-balai': this.longueurBalai + 'px',
        'stroke-dasharray': `${this.longueurBalai} ${this.longueurPiste}`
      }
    },

    repartitionsColorData () {
      return {
        center: getTextColorData(this.centerColor),
        negative: getTextColorData(this.negativeColor),
        positive: getTextColorData(this.positiveColor)
      }
    },

    iconCenterColorData () {
      return getTextColorData(this.iconCenterColor)
    },

    sizeStyles () {
      return {
        width: `${this.size}px`,
        height: `${this.size}px`
      }
    },

    avatarSize () {
      return Number(this.size) - Number(this.width) * 2
    },

    valueColorData () {
      if (this.data.value != null && !this.isParametresExploitationIncomplet) {
        if (this.data.value === 'center') {
          return this.iconCenterColorData
        } else {
          return this.repartitionsColorData[this.data.value]
        }
      } else {
        return 'grey'
      }
    },

    diameter () {
      return (this.radius / (1 - Number(this.width) / this.size)) * 2
    },

    strokeWidth () {
      return this.getSvgSize(Number(this.width))
    },

    totalAngle () {
      return 180 - this.angleOffset * 2
    },

    startAngle () {
      return -this.totalAngle / 2
    },

    endAngle () {
      return this.totalAngle / 2
    },

    repartitionsAngles () {
      const repartitionsAngles = {}
      let startAngle = this.startAngle
      for (const position of ['negative', 'center', 'positive']) {
        const endAngle =
          startAngle + this.getAngleFromRepartition(this.repartition[position])

        repartitionsAngles[position] = {
          startAngle,
          endAngle
        }

        startAngle = endAngle
      }

      return repartitionsAngles
    },

    repartitionsCoords () {
      const repartitionsCoords = {}
      for (const position of ['negative', 'center', 'positive']) {
        repartitionsCoords[position] = {
          startCoord: this.getCoord(
            this.repartitionsAngles[position].startAngle
          ),
          endCoord: this.getCoord(this.repartitionsAngles[position].endAngle)
        }
      }

      return repartitionsCoords
    },

    valueMarkerPoints () {
      const hypothenuse = this.getHypothenuse(this.getSvgSize(this.markerSize))
      return this.getTrianglePoints(hypothenuse)
    },

    valueMarkerTransform () {
      return `translate(0, ${-this.getSvgSize(this.avatarSize / 2 - this.markerOffset)})`
    },

    valueMarkerWrapperTransform () {
      if (this.data.value != null && !this.isParametresExploitationIncomplet) {
        const angles = this.repartitionsAngles[this.data.value]
        return `rotate(${angles.startAngle + (angles.endAngle - angles.startAngle) / 2})`
      } else {
        return ''
      }
    }
  },

  beforeDestroy () {
    clearTimeout(this.minuterieFermeture)
  },

  methods: {

    onBasculeBulle (estOuverte) {
      this.positionnerFleche(estOuverte)
      this.programmerFermeture(estOuverte)
    },

    fermerBulle () {
      if (this.$refs.menu != null) {
        this.$refs.menu.isActive = false
      }
    },
    programmerFermeture (estOuverte) {
      clearTimeout(this.minuterieFermeture)

      if (estOuverte && this.estVueMobile) {
        this.minuterieFermeture = setTimeout(() => this.fermerBulle(), DUREE_AFFICHAGE_BULLE)
      }
    },

    positionnerFleche (estOuverte) {
      if (!estOuverte || this.estVueMobile) {
        this.positionFleche = null
        return
      }

      mesurerApresPlacement(this, () => {
        this.positionFleche = positionFlecheSousActivateur(this.$refs.jauge, this.$refs.bulle)
        return this.positionFleche
      })
    },

    getSvgSize (pixelSize) {
      return (pixelSize / this.size) * this.diameter
    },

    getAngleFromRepartition (value) {
      return (value * this.totalAngle) / 100
    },

    getCoord (angle) {
      const trigoAngle = -(angle * Math.PI) / 180

      return {
        x: Math.cos(trigoAngle) * this.radius,
        y: -Math.sin(trigoAngle) * this.radius
      }
    },

    getHypothenuse (radius) {
      return Math.sqrt(2 * radius * radius)
    },

    getTrianglePoints (hypothenuse) {
      return `${-hypothenuse / 2} 0, 0 ${-hypothenuse / 2}, ${hypothenuse / 2} 0`
    }
  }
}
</script>

<style lang="scss" scoped>
.user-indicator-jauge {
  align-items: center;
  display: inline-flex;
  justify-content: center;
  position: relative;
  vertical-align: middle;

  > svg {
    width: 100%;
    height: 100%;
    margin: auto;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 0;

    .user-indicator-jauge-quarter {
      transform: rotate(-90deg);
      fill: transparent;
      stroke: currentColor;
    }

    .value-marker {
      fill: currentColor;
      stroke: #ffffff;
    }

    .user-indicator-jauge-piste,
    .user-indicator-jauge-balai {
      transform: rotate(-90deg);
      fill: transparent;
    }

    .user-indicator-jauge-piste {
      stroke: #d3d3d3;
    }

    .user-indicator-jauge-balai {
      stroke: #9a9a93;
      animation: balayage-jauge-groupe 1.6s linear infinite;
    }
  }

  @keyframes balayage-jauge-groupe {
    from {
      stroke-dashoffset: var(--longueur-balai);
    }

    to {
      stroke-dashoffset: calc(-1 * var(--longueur-piste));
    }
  }

  @media (prefers-reduced-motion: reduce) {
    > svg .user-indicator-jauge-balai {
      animation: none;
      stroke-dashoffset: 0;
    }
  }

  .user-indicator-jauge-avatar {
    box-shadow:
      0 3px 1px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)),
      0 2px 2px 0 var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)),
      0 1px 5px 0 var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
  }
}
.menu-item-resume {
  position: relative;
  padding: 16px;
  margin: 14px;
  border-radius: 12px;
  background-color: #ffffff;
  filter: drop-shadow(
      0px 3px 1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2))
    )
    drop-shadow(
      0px 2px 2px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14))
    )
    drop-shadow(
      0px 1px 5px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12))
    );
  &.menu-item-resume__top::after {
    content: '';
    position: absolute;
    z-index: -10;
    width: 20px;
    height: 20px;
    transform: rotate(45deg);
    background-color: #ffffff;
    bottom: -5px;
    left: var(--position-fleche, calc(50% - 10px));
  }
}
.w-260 {
 width: 260px;
}

</style>
